import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'


const Status404NotFound: React.FC = () => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <div>
      {t('status404NotFound', { path: location.pathname })}
    </div>
  )
}


export default Status404NotFound
